/**
 * @file Shared mobile route-title action buttons.
 */

import { canAccessView } from "../../app/routing/boardAccess.js";
import { appData, state } from "../../app/state/state.js";

function getUnreadClass() {
  return (appData.notifications || []).length > 0 ? " has-unread" : "";
}

function renderMobileNotificationButton() {
  return `
    <button
      type="button"
      class="notification-bell-btn header-action-btn text-gray-500 transition-colors${getUnreadClass()}"
      title="Notifications"
      aria-label="Notifications"
      data-mobile-route-notifications
    >
      <span class="material-symbols-outlined text-2xl">notifications</span>
      <div class="unread-badge"></div>
    </button>
  `;
}

function renderMobileRecallQuickAddButton() {
  if (!canAccessView(state.currentUserProfile, "recalls")) {return "";}

  return `
    <button
      type="button"
      class="header-action-btn recall-quick-add-header-btn text-gray-500 transition-colors"
      title="Quick Add Recall"
      aria-label="Quick Add Recall"
      data-mobile-recall-quick-add
    >
      <span class="material-symbols-outlined text-2xl">alarm_add</span>
    </button>
  `;
}

/**
 * Renders mobile-only actions for route title rows.
 * @returns {string} Route-title action HTML.
 */
export function renderMobileRouteHeaderActions() {
  return `
    <div class="flex items-center gap-2 md:hidden" data-mobile-route-header-actions>
      ${renderMobileRecallQuickAddButton()}
      ${renderMobileNotificationButton()}
    </div>
  `;
}

/**
 * Hydrates static mobile route-title action slots.
 * @param {ParentNode} [root=document] Root to search.
 * @returns {void}
 */
export function syncMobileRouteHeaderActionSlots(root = document) {
  root.querySelectorAll("[data-mobile-route-header-actions-slot]")
    .forEach((slot) => {
      slot.innerHTML = renderMobileRouteHeaderActions();
    });
}
